
import React from 'react'
import { Link } from 'react-router-dom'

const NavLink = ({ item, onNavigate }) => {
    if (item.type === 'component') {
        return (
            <div className="px-3">
                {typeof item.component === 'function'
                    ? item.component({ onMobileMenuClose: onNavigate })
                    : item.component}
            </div>
        )
    }

    return (
        <Link
            to={item.to}
            className="group relative py-2 px-3"
            onClick={onNavigate}
        >
      <span className="font-heebo text-base font-bold text-[#8B5E3C] group-hover:text-[#5C4033] transition-colors">
        {item.text}
      </span>
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#8B5E3C] to-[#D4B797] scale-x-0 group-hover:scale-x-100 transition-transform origin-right" />
        </Link>
    )
}

export default NavLink
